var _rect, _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIfThen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 19,
    rx: 2.5,
    stroke: "#1D6295"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 0,
    height: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14645 9.14645C4.95118 9.34171 4.95118 9.65829 5.14645 9.85355L8.32843 13.0355C8.52369 13.2308 8.84027 13.2308 9.03553 13.0355C9.2308 12.8403 9.2308 12.5237 9.03553 12.3284L6.20711 9.5L9.03553 6.67157C9.2308 6.47631 9.2308 6.15973 9.03553 5.96447C8.84027 5.7692 8.52369 5.7692 8.32843 5.96447L5.14645 9.14645ZM18.8536 9.85355C19.0488 9.65829 19.0488 9.34171 18.8536 9.14645L15.6716 5.96447C15.4763 5.7692 15.1597 5.7692 14.9645 5.96447C14.7692 6.15973 14.7692 6.47631 14.9645 6.67157L17.7929 9.5L14.9645 12.3284C14.7692 12.5237 14.7692 12.8403 14.9645 13.0355C15.1597 13.2308 15.4763 13.2308 15.6716 13.0355L18.8536 9.85355ZM5.5 10H18.5V9H5.5V10Z",
    fill: "#1D6295",
    mask: "url(#)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfThen);
export default __webpack_public_path__ + "static/media/if-then.2fb539628d70e121ccaf8a045e7d2e51.svg";
export { ForwardRef as ReactComponent };